import React from 'react';
import styles from './CalculatorDisclaimerModal.module.scss';
import {RMD_CALCULATOR_DISCLAIMER} from "../../../redux/modules/modals/modals.module";
import ButtonBeacon from "../../Beacon/ButtonBeacon";
import Button from "../../Button/Button";
const CalculatorDisclaimerModal = ({onClose}) => {
  return (
      <div className={styles["container-important-info"]}>
      <h1 className={styles["title"]}>RMD Calculator Important Information</h1>
      <div className={styles["sub-title"]}>
        <div className={styles["calculator-info"]}>
          <h4>What this calculator does:</h4>
          <ul>
            <li>
              Based on the information you provide, this calculator helps IRA owners
              estimate the required minimum distribution (RMD) amount that must be
              withdrawn each year from an eligible IRA .  The results from the RMD
              Calculator will be computed based on the information provided by you.
              T. Rowe Price cannot guarantee the accuracy of the results.
            </li>
            <li>
              This RMD Calculator is intended to serve as an informational tool only,
              and should not be construed as legal, investment, or tax advice. You
              should discuss your situation with your tax or estate planning
              professional before acting on the information you receive from this tool.
            </li>
            <li>
              This RMD Calculator utilizes the RMD regulations and the latest life
              expectancy tables (see Appendix B of IRS Publication 590-B), to calculate
              any applicable annual RMDs. The RMD Calculator uses the IRS Uniform Lifetime
              Table to calculate RMD amounts unless you provide the date of birth of your
              sole spousal beneficiary who is 10 years or more younger than you. In that
              case, the tool will use the Joint Life and Survivor Expectancy Table to
              calculate your RMD for the current and for future year projections.
            </li>
          </ul>
        </div>
        <div className={styles["please-note"]}>
          <h4>Please note:</h4>
          <p>
            The RMD for a year is determined by dividing the previous year-end's
            fair market value (on December 31) by the applicable distribution period
            (from the appropriate life expectancy table). The year-end value may need
            to be adjusted for transfers or rollovers in transit.  The RMD amount will
            change every year and needs to be re-calculated annually.
          </p>
          <p>
            This RMD Calculator will not distribute the RMD amount. Request your
            distribution no later than one week prior to the deadline(s) to be sure that
            the RMD occurs before the due date. If you don’t meet your distribution deadline,
            the RMD may be considered late and could have significant tax consequences
            and penalties. 
          </p>
        </div>
        <div className={styles["deadlines"]}>
          <h4>Deadlines:</h4>
          <ul>
            <li>Your first RMD is due by April 1 of the year following the year you reach age 73*</li>
            <li>Your second RMD is due by December 31 of that calendar year. </li>
          </ul>
          <p>
            Non-IRA retirement plans, such as 401(k) or 403(b) plans, may have different
            deadlines - please speak with your plan administrator for details.
          </p>
          <p>
            Roth IRAs do not require withdrawals until after the death of the owner.
            Please note, different RMD rules apply to inherited retirement accounts.
            For questions, please speak to your legal or tax professional.  
          </p>
          <p className={styles["secure-act"]}>
            *The SECURE Act of 2019 changed the RMD age requirement from 70½ to 72
            and is applicable to those who turned 70½ on or after January 1, 2020.
            The Secure 2.0 Act of 2022 changed the RMD age to 73 in 2023 only for
            individuals who turn 72 on or after January 1, 2023. The new law also
            provides that the RMD age will change again to 75 in 2033.
          </p>
        </div>
        <div className={styles["disclosure"]}>
          <h4>Disclosures:</h4>
          <ul>
            <li>You are responsible for the calculation and timely distribution of your RMD from your eligible IRAs.</li>
            <li>Distributions of taxable amounts are subject to ordinary income tax.</li>
            <li>The RMD Calculator does not consider the effect of taxes on the RMD distributed nor does it calculate the tax owed in on the distribution.</li>
          </ul>
        </div>
        <div className={styles["disclaimer"]}>
          T. Rowe Price does not provide tax advice. If you have any questions about how this distribution may affect your personal taxes, you should consult your own accountant or tax professional.
        </div>
        <div>
          <div className={styles["buttonModal"]}>
            <div className={styles["button-object"]}>
              <ButtonBeacon onClick={() => onClose(RMD_CALCULATOR_DISCLAIMER)} label={'Close'} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalculatorDisclaimerModal;
